import { AddCircle, HomeOutlined, Person2Outlined } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";

import { Box } from "@mui/material";

const BottomBar = () => {
    const location = useLocation();
    const navigate = useNavigate();

    return (
        <Box
            display="flex"
            justifyContent="space-evenly"
            alignItems="center"
            position="fixed"
            width="100%"
            bottom={0}
            bgcolor="white"
            height="70px"
        >
            <Box
                position="absolute"
                left="50"
                bottom="40px"
                onClick={() => navigate("/create")}
            >
                <AddCircle sx={{ color: "secondary.main", fontSize: "60px" }} />
            </Box>

            <Box
                width="50%"
                display="flex"
                justifyContent="center"
                onClick={() => navigate("/home")}
            >
                <HomeOutlined
                    sx={{
                        fontSize: "45px",
                        color:
                            location.pathname === "/home" ? "black" : "#d3d3d3",
                    }}
                />
            </Box>

            <Box
                width="50%"
                display="flex"
                justifyContent="center"
                onClick={() => navigate("/profile")}
            >
                <Person2Outlined
                    sx={{
                        fontSize: "45px",
                        color:
                            location.pathname !== "/home" ? "black" : "#d3d3d3",
                    }}
                />
            </Box>
        </Box>
    );
};

export default BottomBar;
